import React, { FC } from "react";

import { isValid } from "date-fns";

import { defaultDateFormat } from "@/core/date";

type DateFormatProps = {
    date: Date | null | undefined;
    fallback?: string | null;
};

const DateFormat: FC<DateFormatProps> = ({ date, fallback = null }) => {
    if (!isValid(date)) {
        return fallback === null ? null : <>{fallback}</>;
    }
    return <>{defaultDateFormat(date)}</>;
};

export default DateFormat;
